<template>
  <div>
    <BContainer fluid>
      <BCol cols="12" class="my-1" align="right">
        <BInput
            v-model="searchTerm"
            @input="getDispenserGuidesBySearchTerm(searchTerm)"
            placeholder="Search by state name or file name"
            aria-label="Search by state name or file name"
            class="col-sm-3"
            align="right"
        >
        </BInput>
      </BCol>
      <br>
      <BTable
          striped
          hover
          :fields="fields"
          :per-page="perPage"
          :items="dispenserGuides"
      >
        <template v-slot:cell(dispenser_guide_file_url)="row">
          <BButton
            size="sm"
            variant="primary"
            v-on:click="previewDispenserGuide(row.item.dispenser_guide_file_url)"
          >
            {{ row.item.dispenser_guide_file_file_name }}
          </BButton>
        </template>
        <template v-slot:cell(actions)="row">
          <BButton
              size="sm"
              variant="primary"
              data-bs-toggle="modal"
              data-bs-target="#deleteConfirmationModal"
              v-on:click="setDispenserGuideIdToDelete(row.item.id)"
          >
            Delete
          </BButton>
        </template>
      </BTable>

      <BRow>
        <BCol cols="12" class="my-1">
          <BPagination
              v-model="currentPage"
              :per-page="perPage"
              :totalRows="totalEntries"
              align="right"
          >
          </BPagination>
        </BCol>
      </BRow>

      <div class="modal fade" id="deleteConfirmationModal" tabindex="-1" aria-labelledby="deleteConfirmationModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="deleteConfirmationModalLabel">Delete dispenser guide</h5>
              <button type="button" class="custom-close" data-bs-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              You are about to delete this dispenser guide. Is this correct?
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Back</button>
              <button type="button" class="btn btn-danger" data-bs-dismiss="modal" @click="deleteDispenserGuide">Delete</button>
            </div>
          </div>
        </div>
      </div>
    </BContainer>
  </div>
</template>

<script>
import axios from "axios"
import { BContainer, BCol, BTable, BInput, BButton, BRow, BPagination } from 'bootstrap-vue-next'

export default {
  data() {
    return {
      dispenserGuides: [],
      searchTerm: '',
      totalEntries: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15],
      filter: null,
      filterOn: [],
      fields: [
        {
          key: 'pmp_name',
          label: 'State'
        },
        {
          key: 'dispenser_guide_file_url',
          label: 'Dispenser Guide'
        },
        {
          key: 'updated_at',
          label: 'Updated at',
          formatter: (value, _key, _item) => {
            return new Date(value).toLocaleDateString("en-US");
          }
        },
        {
          key: 'actions',
          label: 'Actions'
        }
      ],
      dispenserGuideIdToDelete: null
    }
  },
  components: {
    BContainer, BCol, BTable, BInput, BButton, BRow, BPagination
  },
  computed: {
    lookupPath() {
      return `/dispenser_guides`
    }
  },
  methods: {
    getDispenserGuidesBySearchTerm(searchTerm) {
      return (searchTerm.length >= 3 || searchTerm.length == 0) && this.getDispenserGuides()
    },
    getDispenserGuides() {
      let vm = this;

      axios.get(
          vm.lookupPath, {
            params: {
              page: this.currentPage,
              searchTerm: this.searchTerm
            }
          }
      ).then(function (response) {
        vm.dispenserGuides = response.data.dispenser_guides;
        vm.totalEntries = response.data.total_entries;
        vm.errorMessages = [];
      })
      .catch(function (error) {
        vm.errorMessages = [vm.notFoundError];
      });
    },
    previewDispenserGuide(url) {
      window.open(url, "_blank");
    },
    setDispenserGuideIdToDelete(dispenserGuideId) {
      this.dispenserGuideIdToDelete = dispenserGuideId;
    },
    deleteDispenserGuide() {
      let vm = this;

      axios.delete(
        'dispenser_guides/'.concat(this.dispenserGuideIdToDelete)
      ).then(function (response) {
        window.location.href = '/dispenser_guides';
        vm.errorMessages = [];
      })
      .catch(function (error) {
        vm.errorMessages = [vm.notFoundError];
      });
    }
  },
  mounted() {
    this.getDispenserGuides()
  },
  watch: {
    currentPage() {
      this.getDispenserGuides()
    }
  }
}
</script>
